import React from 'react';
import posthog from 'posthog-js';
import Package from '../../../../package.json';
import { ArrayHelpers, Footer, Loading } from '@salesperformanceint/e4shared';

import './zero.css';
import '@salesperformanceint/e4shared/lib/shared-bundle.css';
import { useDispatch, useSelector } from 'react-redux';
import { loadUserFromSession } from 'actions/user';

import DebugHelper from 'components/debugHelper';

export const Zero = ({ children, history, match }) => {
    const dispatch = useDispatch();

    const user = useSelector(state => state.user.user);
    const { text } = useSelector(state => state.ui);

    const id = match.params.guid;

    React.useEffect(() => {
        if (!user && !id) {
            dispatch(loadUserFromSession(history));
        }
    }, []);

    React.useEffect(() => {
        if (user?.id && ArrayHelpers.existsAndHasLength(text)) {
            document.TRANSLATIONS = text;
            posthog.identify(user.unique_Id);
            posthog.capture('zero-review');
            posthog.capture('$set', {
                $set: {
                    roles: user.role_Names,
                    subdomain: user.subDomain,
                    region: 'EU',
                },
            });
        }
    }, [text, user]);

    React.useEffect(() => {
        const addStyle = url => {
            const head = document.head;
            const links = [...document.querySelectorAll('link[rel="stylesheet"]')];

            const alreadyExists = links.some(link => link.href.includes(url));

            if (!alreadyExists) {
                var link = document.createElement('link');
                link.type = 'text/css';
                link.rel = 'stylesheet';
                link.href = url;
                head.appendChild(link);
            }
        };

        const removeStyle = url => {
            const links = [...document.querySelectorAll('link[rel="stylesheet"]')];
            links.forEach(link => {
                if (link.href.includes(url)) {
                    link.remove();
                }
            });
        };

        if (user?.companySettings?.prism_UI) {
            addStyle('/dist/css/prism.css');
            removeStyle('/dist/css/AdminLTE.min.css');
            removeStyle('/dist/css/skins/_all-skins.min.css');
        } else {
            addStyle('/dist/css/AdminLTE.min.css');
            addStyle('/dist/css/skins/_all-skins.min.css');
            removeStyle('/dist/css/prism.css');
        }
    }, [user?.companySettings?.prism_UI]);

    const logoFull = 'richardson-logo-full.svg';

    return (
        <div id="zero">
            <header className="main-header">
                <div className="flex flex-center">
                    <div className="logo">
                        <span className="logo-lg pt3 pull-left">
                            <img
                                src={`/dist/img/${logoFull}`}
                                style={{ width: '150px', height: '24px' }}
                                alt=""
                                loading="lazy"
                            />
                        </span>
                    </div>
                    <div className="text-right flex-grow no-wrap mr20 header-name">{user?.full_Name}</div>
                </div>
            </header>
            <div className="zero-wrapper">
                <div>{user || id ? children : <Loading />}</div>
            </div>
            <DebugHelper />
            <Footer version={Package.version} />
        </div>
    );
};

export default Zero;
